export default [
	{
		path: 'menu-group',
		name:'MenuGroup',
		view: 'MenuGroup',
		folder: 'views/dimenu/setup',
	},	
	{
		path: 'menu-group-add',
		name:'MenuGroupAdd',
		view: 'MenuGroupAdd',
		folder: 'views/dimenu/setup',
	},		
];